import { parseCDMVersion } from '@/constants';
import { AuthorCell, DateCell, NameCell } from '@prometheus/features';
import i18n from 'i18next';
import { DownloadedBundlesCell } from './DownloadedBundlesCell';
import { VocabularyBundleStatus } from '@/types';
import { Chip, Spinner, StatusTag, Tooltip } from '@prometheus/components';
import { errorReasonMap } from '@/utils/errorReasonMap';

export const columns = () => [
  {
    Header: i18n.t('tables.cols.bundle_name'),
    accessor: 'name',
    id: 'name',
    Cell: NameCell,
    width: '60%',
  },
  {
    Header: i18n.t('tables.cols.version'),
    accessor: 'releaseVersion',
    id: 'releaseVersion',
  },
  {
    Header: i18n.t('tables.cols.author'),
    id: 'user',
    accessor: 'user',
    Cell: AuthorCell,
  },
  {
    Header: i18n.t('tables.cols.downloaded_at'),
    id: 'timestamp',
    accessor: 'timestamp',
    Cell: DateCell,
  },
  {
    Header: 'Status',
    id: 'downloadStatus',
    accessor: 'downloadStatus',
    align: 'center',
    minWidth: 100,
    Cell: props => {
      switch (props.value) {
        case VocabularyBundleStatus.DOWNLOADED:
          return (
            <StatusTag
              text={'Downloaded'}
              color="success"
              light
              align="center"
            />
          );
        case VocabularyBundleStatus.FAILED:
        case VocabularyBundleStatus.FAILED_NEW:
        case null:
          return (
            <Tooltip text={errorReasonMap[props.row.original.errorReason]}>
              <div>
                <StatusTag text={'Failed'} color="error" light align="center" />
              </div>
            </Tooltip>
          );
        default:
          return (
            <Chip
              icon={<Spinner size={14} color="secondary" />}
              label="In Progress..."
              size="small"
              sx={{
                borderRadius: 1,
                color: 'textColor.label',
                bgcolor: 'transparent',
                '.MuiChip-icon': {
                  mr: 0.5,
                },
              }}
            />
          );
      }
    },
  },
  {
    Header: '',
    id: 'actions',
    accessor: 'id',
    align: 'center',
    minWidth: 140,
    Cell: DownloadedBundlesCell,
  },
];
